export const Vacation = {
    path: '/vacations',
    name: 'vacations',
    component: () => import('@/views/Absence/Vacation/VacationPage.vue'),
    children: [
        {
            path: '/vacations/add',
            name: 'vacations.add',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/vacations/edit/:id',
            name: 'vacations.edit',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/vacations/delete/:id',
            name: 'vacations.delete',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/vacations/view/:id',
            name: 'vacations.view',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/absence_requests/vacation_title/:id',
            name: 'vacations.vacation_title',
            component: () => import('@/views/Absence/AbsenceRequest/Form/VacationTitle.vue'),
        },
        {
            path: '/vacations/set_decision/:id/:module',
            name: 'vacations.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/vacations/timelines/:id/:module',
            name: 'vacations.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/vacations/documents/:id',
            name: 'vacations.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "VACATION"}
        },
    ],
}


export const VacationBalance = {
    path: '/vacation_balance',
    name: 'vacation_balance',
    component: () => import('@/views/WorkerBalance/WorkerBalanceVacationPage.vue'),
    children: [
        {
            path: '/vacation_balance/manual/produce/:id',
            name: 'vacation_balance.manual.produce',
            component: () => import('@/views/WorkerBalance/Form/ManualForm.vue'),
            props: {produce: true}
        },
        {
            path: '/vacation_balance/manual/consume/:id',
            name: 'vacation_balance.manual.consume',
            component: () => import('@/views/WorkerBalance/Form/ManualForm.vue'),
            props: {consume: true}
        },
        {
            path: '/vacation_balance/manual/gathering/:id',
            name: 'vacation_balance.manual.gathering',
            component: () => import('@/views/WorkerBalance/Form/ManualGathering.vue'),
        },
        {
            path: '/vacation_balance/request/view/:id',
            name: 'vacation_balance.request.view',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/vacation_balance/pay_slip/view/:id',
            name: 'vacation_balance.pay_slip.view',
            component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
        },
        {
            path: '/vacation_balance/init',
            name: 'vacation_balance.init',
            component: () => import('@/views/WorkerBalance/Form/InitWorkerBalanceForm'),
        },
    ]
}

export const VacationCalendar = {
    path: '/vacations_calendar',
    name: 'vacations_calendar',
    component: () => import('@/views/Absence/AbsenceRequest/AbsenceRequestCalendar.vue'),
    props: {holiday: true}
}